(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.kobra = factory());
}(this, function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function every (arr, cb) {
    var i = 0,
        len = arr.length;

    for (; i < len; i++) {
      if (!cb(arr[i], i, arr)) {
        return false;
      }
    }

    return true;
  }

  const SEP = '/'; // Types ~> static, param, any, optional

  const STYPE = 0,
        PTYPE = 1,
        ATYPE = 2,
        OTYPE = 3; // Char Codes ~> / : *

  const SLASH = 47,
        COLON = 58,
        ASTER = 42,
        QMARK = 63;

  function strip(str) {
    if (str === SEP) return str;
    str.charCodeAt(0) === SLASH && (str = str.substring(1));
    var len = str.length - 1;
    return str.charCodeAt(len) === SLASH ? str.substring(0, len) : str;
  }

  function split(str) {
    return (str = strip(str)) === SEP ? [SEP] : str.split(SEP);
  }

  function isMatch(str, obj) {
    return obj.val === str && obj.type === STYPE || (str === SEP ? obj.type > PTYPE : obj.type !== STYPE && (str || '').endsWith(obj.end));
  }

  function match(str, all) {
    let segs = split(str),
        len = segs.length,
        l;

    let i = 0,
        tmp,
        fn = (o, x) => isMatch(segs[x], o);

    for (; i < all.length; i++) {
      tmp = all[i];

      if ((l = tmp.length) === len || l < len && tmp[l - 1].type === ATYPE || l > len && tmp[l - 1].type === OTYPE) {
        if (every(tmp, fn)) return tmp;
      }
    }

    return [];
  }
  function parse(str) {
    if (str === SEP) {
      return [{
        old: str,
        type: STYPE,
        val: str,
        end: ''
      }];
    }

    let c,
        x,
        t,
        sfx,
        nxt = strip(str),
        i = -1,
        j = 0,
        len = nxt.length,
        out = [];

    while (++i < len) {
      c = nxt.charCodeAt(i);

      if (c === COLON) {
        j = i + 1; // begining of param

        t = PTYPE; // set type

        x = 0; // reset mark

        sfx = '';

        while (i < len && nxt.charCodeAt(i) !== SLASH) {
          c = nxt.charCodeAt(i);

          if (c === QMARK) {
            x = i;
            t = OTYPE;
          } else if (c === 46 && sfx.length === 0) {
            sfx = nxt.substring(x = i);
          }

          i++; // move on
        }

        out.push({
          old: str,
          type: t,
          val: nxt.substring(j, x || i),
          end: sfx
        }); // shorten string & update pointers

        nxt = nxt.substring(i);
        len -= i;
        i = 0;
        continue; // loop
      } else if (c === ASTER) {
        out.push({
          old: str,
          type: ATYPE,
          val: nxt.substring(i),
          end: ''
        });
        continue; // loop
      } else {
        j = i;

        while (i < len && nxt.charCodeAt(i) !== SLASH) {
          ++i; // skip to next slash
        }

        out.push({
          old: str,
          type: STYPE,
          val: nxt.substring(j, i),
          end: ''
        }); // shorten string & update pointers

        nxt = nxt.substring(i);
        len -= i;
        i = j = 0;
      }
    }

    return out;
  }
  function exec(str, arr) {
    let i = 0,
        x,
        y,
        segs = split(str),
        out = {};

    for (; i < arr.length; i++) {
      x = segs[i];
      y = arr[i];
      if (x === SEP) continue;

      if (x !== void 0 && y.type | 2 === OTYPE) {
        out[y.val] = x.replace(y.end, '');
      }
    }

    return out;
  }

  var route = function route(url) {
    window.history.pushState(undefined, undefined, url);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };
  var Router =
  /*#__PURE__*/
  function () {
    function Router() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'history';

      _classCallCheck(this, Router);

      this.type = type;
      this.routes = [];
      this.handlers = {};
    }

    _createClass(Router, [{
      key: "getCurrent",
      value: function getCurrent(cb) {
        var arr = match(this.path, this.routes);
        var params = exec(this.path, arr);
        var handler = this.handlers[(arr[0] || {}).old || this.path];
        cb(handler, params);
      }
    }, {
      key: "on",
      value: function on(pattern, handler) {
        this.routes.push(parse(pattern));
        this.handlers[pattern] = handler;
      }
    }, {
      key: "listen",
      value: function listen(cb) {
        ['load', {
          hash: 'hashchange',
          history: 'popstate'
        }[this.type]].forEach(function (event) {
          window.addEventListener(event, cb);
        });
      }
    }, {
      key: "path",
      get: function get() {
        return {
          history: document.location.pathname,
          hash: document.location.hash.substring(1) || '/'
        }[this.type];
      }
    }]);

    return Router;
  }();

  function extend(obj, props) {
    for (var i in props) {
      obj[i] = props[i];
    }

    return obj;
  }
  function isEvent(name) {
    return /^on/.test(name);
  }

  var handleClick = function handleClick(url) {
    return function (event) {
      event.preventDefault();
      route(url);
    };
  };

  function createInternalLinkAttributes(attributes) {
    if (!attributes.href) return attributes;
    if (/^https?:\/\//.test(attributes.href)) return attributes;
    if (attributes.target && attributes.target === '_blank') return attributes;
    return extend(extend({}, attributes), {
      onClick: handleClick(attributes.href)
    });
  }

  function h(nodeName, attributes) {
    var length = arguments.length;
    var children = [];
    attributes = attributes || {};

    while (length-- > 2) {
      children.push(arguments[length]);
    }

    if (nodeName === 'a') {
      attributes = createInternalLinkAttributes(attributes);
    }

    return {
      nodeName: nodeName,
      attributes: attributes,
      children: [].concat.apply([], children.reverse())
    };
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function createStore(actions, state) {
    var subscriptions = [];
    var mappedActions = {};

    var globalState = _extends({}, state);

    for (var _i = 0, _Object$entries = Object.entries(actions); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _Object$entries[_i],
          key = _Object$entries$_i[0],
          fn = _Object$entries$_i[1];

      (function (name, action) {
        mappedActions[name] = function (data) {
          var newState = action(data);

          if (typeof newState === 'function') {
            newState = newState(globalState, mappedActions);
          }

          if (newState && !(newState instanceof Promise)) {
            globalState = _extends({}, globalState, {}, newState);
            subscriptions.forEach(function (subscription) {
              subscription(globalState, name);
            });
          }
        };
      })(key, fn);
    }

    var store = {
      actions: mappedActions,
      getState: function getState() {
        return globalState;
      },
      subscribe: function subscribe(listener) {
        subscriptions.push(listener);
      }
    };
    return store;
  }

  var REMOVE = 'REMOVE';
  var UPDATE = 'UPDATE';
  var CREATE = 'CREATE';
  var REPLACE = 'REPLACE';
  var SET_ATTRIBUTE = 'SET_ATTRIBUTE';
  var REMOVE_ATTRIBUTE = 'REMOVE_ATTRIBUTE';

  function diffChildren(newNode, oldNode) {
    var patches = [];
    var patchesLength = Math.max(newNode.children.length, oldNode.children.length);

    for (var i = 0; i < patchesLength; i++) {
      patches[i] = diff(newNode.children[i], oldNode.children[i]);
    }

    return patches;
  }

  function diffAttributes(newNode, oldNode) {
    var patches = [];
    var attributes = Object.assign({}, newNode.attributes, oldNode.attributes);
    Object.keys(attributes).forEach(function (name) {
      var newVal = newNode.attributes[name];
      var oldVal = oldNode.attributes[name];

      if (typeof newVal === 'function' || typeof oldVal === 'function') {
        patches.push({
          type: REMOVE_ATTRIBUTE,
          name: name,
          value: oldVal
        }, {
          type: SET_ATTRIBUTE,
          name: name,
          value: newVal
        });
      }

      if (!newVal) patches.push({
        type: REMOVE_ATTRIBUTE,
        name: name,
        value: oldVal
      });else if (!oldVal || oldVal !== newVal) patches.push({
        type: SET_ATTRIBUTE,
        name: name,
        value: newVal
      });
    });
    return patches;
  }

  function diff(newNode, oldNode) {
    if (!oldNode) return {
      type: CREATE,
      newNode: newNode
    };
    if (!newNode) return {
      type: REMOVE
    };
    if (changed(newNode, oldNode)) return {
      type: REPLACE,
      newNode: newNode
    };
    if (newNode.nodeName) return {
      type: UPDATE,
      children: diffChildren(newNode, oldNode),
      attributes: diffAttributes(newNode, oldNode)
    };
  }

  function changed(node1, node2) {
    return _typeof(node1) !== _typeof(node2) || typeof node1 === 'string' && node1 !== node2 || node1.nodeName !== node2.nodeName;
  }

  function createElement(vnode, isSvg) {
    var node = typeof vnode === 'string' || typeof vnode === 'number' ? document.createTextNode(vnode) : (isSvg = isSvg || vnode.nodeName === 'svg') ? document.createElementNS('http://www.w3.org/2000/svg', vnode.nodeName) : document.createElement(vnode.nodeName);

    if (vnode.attributes) {
      if ((vnode.attributes.hook || {}).mount) {
        vnode.attributes.hook.mount(node);
      }

      for (var name in vnode.attributes) {
        if (isEvent(name)) {
          node.addEventListener(name.slice(2).toLowerCase(), vnode.attributes[name]);
        } else {
          if (name === 'className') {
            node.setAttribute('class', vnode.attributes[name]);
          } else if (name !== 'hook') {
            node.setAttribute(name, vnode.attributes[name]);
          }
        }
      }

      for (var i = 0; i < vnode.children.length; i++) {
        node.appendChild(createElement(vnode.children[i], isSvg));
      }
    }

    return node;
  }

  function setAttribute(node, name, value) {
    if (isEvent(name)) node.addEventListener(name.slice(2).toLowerCase(), value);else if (name === 'className') node.setAttribute('class', value);else if (name === '__html') node.innerHTML = value;else if (name !== 'hook') node.setAttribute(name, value);
  }

  function removeAttribute(node, name, value) {
    if (isEvent(name)) node.removeEventListener(name.slice(2).toLowerCase(), value);else if (name === 'className') node.removeAttribute('class');else if (name === '__html') node.innerHTML = '';else node.removeAttribute(name);
  }

  function patchAttributes(parent, patches) {
    for (var i = 0; i < patches.length; i++) {
      var attribute = patches[i];
      var type = attribute.type,
          name = attribute.name,
          value = attribute.value;
      if (type === SET_ATTRIBUTE) setAttribute(parent, name, value);else if (type === REMOVE_ATTRIBUTE) removeAttribute(parent, name, value);
    }
  }

  function patch(parent, patches) {
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (!patches) return;
    var el = parent.childNodes[index];

    switch (patches.type) {
      case CREATE:
        {
          var newNode = patches.newNode;
          var newElement = createElement(newNode);
          return parent.appendChild(newElement);
        }

      case REMOVE:
        return parent.removeChild(el);

      case REPLACE:
        {
          var _newNode = patches.newNode;

          var _newElement = createElement(_newNode);

          return parent.replaceChild(_newElement, el);
        }

      case UPDATE:
        {
          var children = patches.children,
              attributes = patches.attributes;
          attributes.forEach(function (attribute) {
            if (attribute.name === 'hook' && attribute.value.update) {
              attribute.value.update(el);
            }
          });
          patchAttributes(el, attributes);

          for (var i = 0; i < children.length; i++) {
            patch(el, children[i], i);
          }
        }
    }
  }

  var tree = null;
  function render(newNode, parent) {
    newNode = createVDOM(newNode);
    var patches = diff(newNode, tree);
    patch(parent, patches);
    tree = newNode;
  }

  function createVDOM(vnode) {
    var newVNode = extend(extend({}, vnode), {
      children: (vnode.children || []).filter(Boolean).map(function (child) {
        return typeof child === 'string' || typeof child === 'number' ? child.toString() : createVDOM(child);
      })
    });
    return typeof vnode.nodeName === 'function' ? createVDOM(vnode.nodeName(vnode.attributes, vnode.children)) : newVNode;
  }

  var Kobra =
  /*#__PURE__*/
  function () {
    function Kobra() {
      _classCallCheck(this, Kobra);

      this.__c = undefined; // app container

      this.__s = undefined; // state store
      // events

      this.__e = {
        load: [],
        route: [],
        state: []
      };
      this.__r = new Router('history'); // router
    }

    _createClass(Kobra, [{
      key: "render",
      value: function render$1() {
        var _this = this;

        this.__r.getCurrent(function (handler, params) {
          var actions = _this.__s ? _this.__s.actions : {};
          var state = _this.__s ? _this.__s.getState() : {};
          extend(state, {
            params: params || {}
          });
          var view = handler(state, actions);

          render(view, _this.__c);
        });
      }
    }, {
      key: "store",
      value: function store(actions, initialState) {
        var _this2 = this;

        this.__s = createStore(actions, initialState);

        this.__s.subscribe(function () {
          setTimeout(function () {
            return _this2.render();
          });

          _this2.__e.state.map(function (fn) {
            return fn(_this2.__s.getState(), _this2.__s.actions);
          });
        });

        return this;
      }
    }, {
      key: "route",
      value: function route(pattern, handler) {
        this.__r.on(pattern, handler);

        return this;
      }
    }, {
      key: "on",
      value: function on(name, fn) {
        if (name in this.__e) {
          this.__e[name].push(fn);
        }

        return this;
      }
    }, {
      key: "mount",
      value: function mount(parent) {
        var _this3 = this;

        this.__c = parent;
        var actions = this.__s ? this.__s.actions : {};
        var state = this.__s ? this.__s.getState() : {};

        this.__r.listen(function () {
          _this3.__e.route.map(function (fn) {
            return fn(state, actions);
          });

          _this3.render();
        });

        this.__e.load.map(function (fn) {
          return fn(state, actions);
        });
      }
    }]);

    return Kobra;
  }();
  var kobra = function kobra() {
    return new Kobra();
  };

  function cloneElement(vnode, props) {
    return h(vnode.nodeName, extend(vnode.attributes, props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
  }

  var index = {
    h: h,
    cloneElement: cloneElement,
    kobra: kobra,
    route: route
  };

  return index;

}));
